module.exports = __webpack_public_path__ + "img/14.cf7748f7.png";